import {
  ARBITRUM_CHAIN_ID,
  BLESSNET_CHAIN_ID,
} from "@/features/bridge/constants/bridge.constant";

/**
 * Returns true when the route is between Blessnet (child) and Arbitrum (parent),
 * in either direction.
 */
export const isParentChildRoute = (
  originChainId: number,
  destinationChainId: number,
): boolean => {
  const isChildToParent =
    originChainId === BLESSNET_CHAIN_ID &&
    destinationChainId === ARBITRUM_CHAIN_ID;
  const isParentToChild =
    originChainId === ARBITRUM_CHAIN_ID &&
    destinationChainId === BLESSNET_CHAIN_ID;

  return isChildToParent || isParentToChild;
};
